const groupName = 'Badging';
export const badgingOrgPermissions = {
    'manage-badges': {
        group: groupName,
        label: 'Manage Badges',
    },
    'manage-account-badges': {
        group: groupName,
        label: 'Manage Account Badges',
    },
    'revoke-account-badges': {
        group: groupName,
        label: 'Revoke Account Badges',
    },
};
